export default __webpack_public_path__ + "static/media/IMG_5388.3f419904.WEBP";